import { httpClient } from '../http/httpClient'

export interface UserAccessResponse {
  code: string
}

export const userAccess = async (): Promise<UserAccessResponse> => {
  const { data } = await httpClient
    .post<UserAccessResponse>('/user/access')
    .catch((e) => {
      throw e?.response?.data || e
    })

  return data
}
